export default __webpack_public_path__ + "static/media/post_logo_sketch.350de06a.png";